import { authorizeIfLoggedIn } from "../../../components/Auth/AuthorizedApiClientBase";
import { PropertyClient } from "./generated/PropertyClient"

export const PropertyClientFactory = () => {
    const propertyClient = new PropertyClient(process.env.PROPERTY_BACKEND_URL);
    authorizeIfLoggedIn(propertyClient);

    return propertyClient;
}